import React, { useState, useEffect } from 'react';
import { Input, Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { parsePhoneNumber } from 'awesome-phonenumber';

const { Option } = Select;

const PhoneInput = ({ value, onChange, placeholder }) => {
  const [prefix, setPrefix] = useState('+421');
  // `internalNumber` holds the value of the text input field.
  const [internalNumber, setInternalNumber] = useState('');

  // This effect runs when the `value` prop from the parent changes.
  // It parses the full phone number and updates the component's internal state (`prefix` and `internalNumber`).
  useEffect(() => {
    // Avoid running this logic if the change was triggered by this component itself.
    const currentValue = `${prefix.replace('+', '')}${internalNumber}`;
    if (value === currentValue) {
      return;
    }

    if (value) {
      let pn = parsePhoneNumber(value, { regionCode: 'SK' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'CZ' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'AT' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'HU' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'PL' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'DE' });
      if (!pn.valid) pn = parsePhoneNumber(value, { regionCode: 'UA' });
      if (!pn.valid) pn = parsePhoneNumber(value);

      if (pn.valid) {
        setPrefix(`+${pn.countryCode}`);
        
        let displayNumber = pn.number.national.replace(/\s/g, '');
        
        // Odstraň nulu u SK a AT čísel
        if ([421, 43].includes(pn.countryCode) && displayNumber.startsWith('0')) {
          displayNumber = displayNumber.substring(1);
        }
        
        setInternalNumber(displayNumber);
      } else {
        // If parsing fails, it's likely an incomplete number. We just display it.
        setInternalNumber(value);
      }
    } else {
      // Reset if the parent provides an empty value.
      setInternalNumber('');
      setPrefix('+421');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handlePrefixChange = (newPrefix) => {
    setPrefix(newPrefix);
    // Notify parent about the change with the new combined value.
    //onChange(`${newPrefix.replace('+', '')}${internalNumber}`);
    handleChange(newPrefix, internalNumber)
  };

  const handleNumberChange = (e) => {
    const newNumber = e.target.value;
    setInternalNumber(newNumber);
    // Notify parent about the change with the new combined value.
    //MA: PROC NEMEMINME INTERNALNUMBER?, RESP. PROC NEREAGUJEME NA ZMENU V useEffectu VYS A VOLAME ZMENU TAKHLE ZVLAST JEDNOU TAK A PODRUHE JINAK?????
    //onChange(`${prefix.replace('+', '')}${newNumber}`);

    handleChange(prefix, newNumber)
  };

  const handleChange = (prefix, phoneNumber) => {
    const value = (typeof phoneNumber === "string" && phoneNumber.length > 0) ? `${prefix.replace('+', '')}${phoneNumber}` : ""
    onChange(value)
  }


  const prefixSelector = (
    <Select
      value={prefix}
      onChange={handlePrefixChange}
      suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
    >
      <Option value="+421"><span className="fi fi-sk"></span> +421</Option>
      <Option value="+420"><span className="fi fi-cz"></span> +420</Option>
      <Option value="+43"><span className="fi fi-at"></span> +43</Option>
      <Option value="+36"><span className="fi fi-hu"></span> +36</Option>
      <Option value="+48"><span className="fi fi-pl"></span> +48</Option>
      <Option value="+49"><span className="fi fi-de"></span> +49</Option>
      <Option value="+380"><span className="fi fi-ua"></span> +380</Option>

    </Select>
  );

  return (
    <Input
      value={internalNumber} // The input is now controlled by internalNumber
      placeholder={placeholder}
      onChange={handleNumberChange}
      addonBefore={prefixSelector}
    />
  );
};

export default PhoneInput;
